import React, { useState, useEffect } from 'react';
import api from '../api';
import { toast } from 'react-toastify';

const pages = ['about', 'contact', 'location'];

export default function AdminPageEditor() {
  const [selected, setSelected] = useState('about');
  const [content, setContent] = useState('');
  const token = localStorage.getItem('token');

  const loadContent = async () => {
    try {
      const res = await api.get(`/pages/${selected}`);
      setContent(res.data.content || '');
    } catch {
      toast.error('Failed to load content');
    }
  };

  const saveContent = async () => {
    if (!token) return toast.error('Unauthorized. Please login again.');

    try {
      await api.post(`/pages/${selected}`, { content }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success('Saved');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Failed to save');
    }
  };

  useEffect(() => {
    loadContent();
  }, [selected]);

  return (
    <div className="container py-5">
      <h3>Edit Page Content</h3>
      <select className="form-select mb-3" value={selected} onChange={e => setSelected(e.target.value)}>
        {pages.map(p => <option key={p} value={p}>{p.toUpperCase()}</option>)}
      </select>
      <textarea
        className="form-control mb-3"
        rows={10}
        value={content}
        onChange={e => setContent(e.target.value)}
      />
      <button className="btn btn-primary" onClick={saveContent}>Save</button>
    </div>
  );
}
